/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import workgroupService from '@/modules/Flexigo/services/workgroup';

export default {
  state: {
    allWorkgroupInstances: [],
    workgroups: [],
    isWorkgroupLoading: false,
    steps: {
      step1: undefined,
      step2: undefined,
      step3: undefined,
    },
    refreshData: false,
  },

  mutations: {
    CLEAN_STEPS(state) {
      state.steps = {
        step1: undefined,
        step2: undefined,
        step3: undefined,
      };
      state.refreshData = !state.refreshData;
    },
    SET_FORM_STEP(state, payload) {
      const { step, data } = payload;
      state.steps[step] = data;
    },
    SET_ALL_WORKGROUP_INSTANCES(state, payload) {
      state.allWorkgroupInstances = payload;
    },
    SET_WORKGROUPS_DATA(state, payload) {
      state.workgroups = payload;
    },
    SET_IS_WORKGROUP_LOADING(state, payload) {
      state.isWorkgroupLoading = payload;
    },
    SET_TO_TERMINAL_REFERENCES(state, payload) {
      state.steps.step2.toTerminalReferences = payload;
    },
    SET_FROM_TERMINAL_REFERENCES(state, payload) {
      state.steps.step2.fromTerminalReferences = payload;
    },
    SET_CAMPUS_PATH(state, payload) {
      const { type, polyline } = payload;
      state.steps.step3.campusPath[type] = polyline;
    },
  },

  actions: {
    async fetchWorkgroups({ commit }, workgroupType = 'SHUTTLE') {
      commit('SET_IS_WORKGROUP_LOADING', true);
      try {
        const response = await workgroupService.getAll(workgroupType);
        commit('SET_WORKGROUPS_DATA', response || []);
        return response.data;
      } catch (error) {
        console.error('Error fetching workgroups:', error);
        commit('SET_WORKGROUPS_DATA', []);
        throw error;
      } finally {
        commit('SET_IS_WORKGROUP_LOADING', false);
      }
    },
  },

  getters: {
    workgroupInstances(state) {
      return state.allWorkgroupInstances;
    },
    defaultWorkgroupInstance(state) {
      return state.allWorkgroupInstances.filter((w) => w.isDefault);
    },
    allWorkgroupTemplates(state) {
      const data = state.workgroups;
      const templates = data?.templates || [];
      return templates;
    },
    isWorkgroupLoading(state) {
      return state.isWorkgroupLoading;
    },
    getWorkgroupByTemplateId: (state) => (templateId) => {
      const data = state.workgroups;
      const templates = data?.templates || data || [];
      return templates.find((w) => w.id === templateId);
    },
  },
};

/* eslint-enable no-param-reassign */
/* eslint-enable no-unused-vars */
